define([
    "jquery",
    "underscore",
    "marionette",
    "forms/login/user_reset_password_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function ($, _, Marionette, ChangePasswordForm, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'submitBtn': '#submit_btn',
            'password': '#password',
            'confirmPassword': '#confirm_password',
        },

        events: {
            'click @ui.submitBtn': 'submit',
            "keyup @ui.password": "passwordValidation",
            "keyup @ui.confirmPassword": "isSamePasswordValidation",
        },

        initialize: function () {
            if (window.form_error) {
                this.triggerMethod('show:errors', window.form_error);
                window.form_error = null;
            }
        },

        passwordValidation: function (e) {
            let password = e.target.value;
            let errorFound = false;

            // 글자수 8자 이상, 15자 이하
            let lengthRule = /^.{8,15}$/;
            if (lengthRule.test(password)) {
                document.getElementsByClassName("length")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("length")[0].style.display = "flex";
            }

            // 숫자 하나 이상 포함
            let digitRule = /\d/;
            if (digitRule.test(password)) {
                document.getElementsByClassName("number")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("number")[0].style.display = "flex";
            }

            // 특수문자 하나 이상 포함
            let specialCharRule = /[!@#$%^*+=-]+/;
            if (specialCharRule.test(password)) {
                document.getElementsByClassName("special-character")[0].style.display =
                    "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("special-character")[0].style.display =
                    "flex";
            }

            // 염문 대문자/소문자 포함
            let uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
            if (uppercaseRule.test(password)) {
                document.getElementsByClassName("uppercase")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("uppercase")[0].style.display = "flex";
            }

            if (errorFound) {
                document.getElementsByClassName("first-validation-box")[0].style.display =
                    "flex";
            } else {
                document.getElementsByClassName("first-validation-box")[0].style.display =
                    "none";
            }
        },

        isSamePasswordValidation: function (e) {
            let passwordForConfirm = e.target.value;
            if (
                document.getElementById("password").value === passwordForConfirm
            ) {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "none";
            } else {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "flex";
            }
        },



        submit: function (e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
            var form = new ChangePasswordForm();
            form.set(formData);

            var errors = form.validate();

            var that = this;
            if (_.size(errors) < 1) {
                form.validateWithServer({
                    type: 'POST',
                    success: function (model, res) {
                        that.$('#form_submit').submit();
                    },
                    error: function (model, error) {
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            } else {
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});